import React, { useState, useEffect } from "react";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    FormControlLabel, FormLabel,
    Menu
} from "@mui/material";
// import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import {
    resetGetCustomerIdAndNameList,
    getCustomerIdAndNameList,
} from "../../redux/actions/getCustomerIdAndNameListAction";
import { getCustomerIDANDNameAdminList } from "../../redux/actions/getCustomerIdAndNameAdminListAction"
// import Autocomplete, {
//     createFilterOptions,
// } from "@mui/material/lab/Autocomplete";
import Autocomplete from "@mui/lab/Autocomplete";
import { createFilterOptions } from "@mui/material";
import SOLogout from "../../components/Logout/SOLogout";
import { getWayList, resetGetWayList } from "../../redux/actions/getWayListAction";
import { getWayListAdmin } from "../../redux/actions/getWayListAdminAction"
import { allGatewayMappingList, resetAllGatewayMappingList } from "../../redux/actions/getAllGatewayMappingListAction";
import { getWalletOwnerIdAndNameList, resetGetWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import { createGatewayMapping, resetCreateGatewayMapping } from "../../redux/actions/createGatewayMappingAction";
import { adminGetIntegrationTypeList, resetAdminGetIntegrationTypeList } from "../../redux/actions/adminGetIntegrationTypeListAction";
import { adminGetIntegrationList } from "../../redux/actions/adminGetIntegrationListAction";
import { adminDeleteIntegration, resetAdminDeleteIntegration } from "../../redux/actions/adminDeleteIntegrationAction";
import { adminAddIntegration, resetAdminAddIntegration } from "../../redux/actions/adminAddIntegrationAction";
import { getPaymentModeList, resetGetPaymentModeList } from "../../redux/actions/getPaymentModeListAction";
import { getPaymentBrandList, resetGetPaymentBrandList } from "../../redux/actions/getPaymentBrandListAction";
import { resetDeleteGatewayMapping, deleteGatewayMapping } from "../../redux/actions/deleteGatewayMappingAction";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
// import EditIcon from "@mui/icons-material/Edit";
// import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
// import Tooltip from "@mui/material/Tooltip";
import { Tooltip } from "antd";
import BackButton from "../../components/BackButton/BackButton";
import { AiOutlineSearch } from "react-icons/ai";
import Util from "../../validation";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import { getDefaultCurrencyList } from "../../redux/actions/adminCurrencyListAction";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import val from "../../getThemeDetails";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";



const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});
const AdminMemberMapping = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const filterOptions = createFilterOptions({
        matchFrom: "any",
        limit: 500,
    });

    // useStates
    const [memberId, setMemberId] = useState("");
    const [page, setPage] = useState(0);
    const [deleteMapId, setDeleteMapId] = useState("");
    const [integrationname, setIntegrationName] = useState("");
    const [addOpen, setAddOpen] = React.useState(false);
    const [Open, setOpen] = React.useState(false);
    const [openConfirm, setopenConfirm] = React.useState(false);
    const [getWalletOwnerIdStatus, setGetWalletOwnerIdStatus] = useState(false);
    const [tableMappingList, setTableMappingList] = useState([]);
    const [getWalletOwnerIdResArray, setGetWalletOwnerIdResArray] = useState([]);
    const [searchWalletOwnerId, setSearchWalletOwnerId] = useState("");
    const [searchWalletOwnerIdModal, setSearchWalletOwnerIdModal] = useState("");
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [pageNo, setPageNo] = useState(0)

    const [getIntegrationListArray, setGetIntegrationListArray] = useState([]);
    const [getIntegrationListStatus, setGetIntegrationListStatus] =
        useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [memberSearch, setMemberSearch] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const [searchIntegrationType, setSearchIntegrationType] = useState("");
    const [getIntegrationTypeArray, setGetIntegrationTypeArray] = useState([]);
    const [dialogIntegrationType, setDialogIntegrationType] = useState("");


    const [selectedGateway, setSelectedGateway] = useState({
        gatewayId: "",
        integrationName: ""
    });




    const [user, setUser] = useState({
        MemberID: "",
        PayModeID: "",
        CardTypeID: "",
        Gateway: "",
        Currency: "",
    });

    const {
        MemberID,
        PayModeID,
        CardTypeID,
        Gateway,
    } = user;

    const onInputChange = ({ target: { name, value } }, type) => {

        const obj = {
            ...user
        };

        // validations
        if (type == "number") {
            obj[name] = Util.verifyMobile(value) ? value : obj[name];
        } else if (type == "alphabet") {
            obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
        } else if (type == "both") {
            obj[name] = Util.alphaNumeric(value) ? value : obj[name];
        } else if (type == "url") {
            obj[name] = Util.verifyUrl(value) ? value : obj[name];
        } else {
            // obj[name] = value.trim()
            //obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
            // obj[name] = value.length ? value : obj[name];
            obj[name] = value;
        }
        setUser(obj);
    };


    // useSelectors
    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );
    var authToken = regenerateTokenRes.data.AuthToken;

    const getCustomerIdAndNameListRes = useSelector(
        ({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
    );

    const getCustomerIdAndNameAdminListRes = useSelector(
        ({ adminGetCustomerIdNamesLists }) => adminGetCustomerIdNamesLists
    );
    const getWayListRes = useSelector(({ getWayList }) => getWayList);
    console.log("getWayListRes", getWayListRes)

    const getWayListAdminRes = useSelector(({ adminGateWayLists }) => adminGateWayLists);
    console.log("getWayListAdminRes", getWayListAdminRes)


    const deleteMapping = useSelector(({ deleteGatewayMapping }) => deleteGatewayMapping);

    const getAllGatewayMappingListRes = useSelector(
        ({ getAllGatewayMappingList }) => getAllGatewayMappingList
    )
    console.log("getAllGatewayMappingListResddd", getAllGatewayMappingListRes)

    const getPaymentBrandListRes = useSelector(
        ({ getPaymentBrandList }) => getPaymentBrandList)
    console.log("getPaymentBrandListRes", getPaymentBrandListRes)

    const getPaymentModeListRes = useSelector(
        ({ getPaymentModeList }) => getPaymentModeList)

    const getIntegrationTypeListRes = useSelector(
        ({ adminGetIntegrationType }) => adminGetIntegrationType
    );

    const getWalletOwnerIdRes = useSelector(
        ({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList
    );

    const createGatewayMappingRes = useSelector(
        ({ createGatewayMapping }) => createGatewayMapping
    )

    const adminCurrencyList = useSelector(
        ({ adminCurrencyList }) => adminCurrencyList
    );

    const login = useSelector(({ login }) => login);


    const handleChangePageForward = (event, newPage) => {
        console.log("Arrow", newPage)

        setPageNo(newPage);

        // getWalletTransactionListReq()
        //console.log("Arrow", newPage)
    };
    const handleChangeRowsPerPage = (event) => {

        const newRowsPerPage = parseInt(event.target.value, 10);
        const currentFirstRowIndex = pageNo * rowsPerPage;
        const newPage = Math.floor(currentFirstRowIndex / newRowsPerPage);
        setRowsPerPage(newRowsPerPage);
        // setPageNo(0); // reset to first page
        setPageNo(newPage);
    };
    // const handleChangeRowsPerPage = (event) => {

    //     setRowsPerPage(parseInt(event.target.value));
    //     setPageNo(0);

    // };
    // const handleChangeRowsPerPage = (event) => {
    //     const newRowsPerPage = parseInt(event.target.value, 10);
    //     const currentFirstRowIndex = pageNo * rowsPerPage;
    //     const newPage = Math.floor(currentFirstRowIndex / newRowsPerPage);

    //     setRowsPerPage(newRowsPerPage);
    //     setPageNo(newPage);
    // };
    // useEffect
    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            const getCustomerIdAndNameReq = {
                loginDetails: {
                    walletOwnerId: regenerateTokenRes.data.partnerId || "",
                },
                actionCustomerMasterRequestVO: {
                    customerNameOrId: "",
                },
            };

            dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
        }
    }, [regenerateTokenRes.data.status]);

    useEffect(() => {
        if (PayModeID && CardTypeID) {
            console.log("first GateWay", regenerateTokenRes.data.partnerId)
            if (regenerateTokenRes.data.status == "success") {
                const getWayListReq = {
                    walletOwnerId: regenerateTokenRes.data.partnerId || "",
                    paymentBrand: PayModeID,
                    paymentMode: CardTypeID
                };
                dispatch(getWayList(getWayListReq, authToken));
            }
        }
    }, [regenerateTokenRes.data.status, PayModeID, CardTypeID]);

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            getWalletOwnerIdAndNameListReq();
            getIntegrationTypeListReq();
            const getWayListReq = {
                walletOwnerId: regenerateTokenRes.data.partnerId || "",
                paymentBrand: "",
                paymentMode: "",
            };
            dispatch(getWayList(getWayListReq, authToken));
        }
    }, [regenerateTokenRes.data.status]);

    useEffect(() => {
        if (createGatewayMappingRes.success) {
            setAddOpen(false);
            NotificationPopups(
                "success",
                "Success",
                createGatewayMappingRes.data.description
            );
        }
        if (createGatewayMappingRes.failed) {
            setAddOpen(false);
            NotificationPopups(
                "error",
                "Failed",
                createGatewayMappingRes.data.description
            );
        }
    }, [createGatewayMappingRes])

    useEffect(() => {
        if (deleteMapping.success) {
            getAllGatewayMappingListReq();
            setopenConfirm(false);
            NotificationPopups(
                "success",
                "Success",
                deleteMapping.data.description
            );
        }
        if (deleteMapping.failed) {
            getAllGatewayMappingListReq();
            setopenConfirm(false);
            NotificationPopups(
                "error",
                "Failed",
                deleteMapping.data.description
            );
        }
    }, [deleteMapping])


    // API Requests
    const getAllGatewayMappingListReq = () => {
        setIsLoading(true);
        setGetIntegrationListStatus(true);
        console.log("memberId.split('-')[0],", memberId.split('-')[0], memberId)
        let req = {
            walletOwnerId: searchWalletOwnerId.split("-")[0] || "",
            merchantId: memberId.split('-')[0],
            gatewayId: integrationname.split('-')[0],
            pageNo: pageNo + 1,
            records: rowsPerPage,
        };
        dispatch(allGatewayMappingList(req, authToken));
    };

    const getAllIntegrationMappingListFunc = () => {
        if (getIntegrationListStatus) {
            if (getAllGatewayMappingListRes.data.status == "success") {
                setIsLoading(false);
                setGetIntegrationListArray(
                    [].concat(getAllGatewayMappingListRes.data.gatewayRequestVOList)
                );
            }
            if (getAllGatewayMappingListRes.data.status == "failed") {
                setIsLoading(false);
                setGetIntegrationListArray(getAllGatewayMappingListRes.data);
                NotificationPopups(
                    "error",
                    "Failed",
                    getAllGatewayMappingListRes.data.description
                );
                if (
                    getAllGatewayMappingListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getAllGatewayMappingListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            // if (getAllGatewayMappingListRes.data.status == "NOT FOUND") {
            //     setIsLoading(false);
            //     setGetIntegrationListArray(getAllGatewayMappingListRes.data);

            // }
            if (getAllGatewayMappingListRes.data.status == "NOT FOUND") {
                setIsLoading(false);
                setGetIntegrationListArray(getAllGatewayMappingListRes.data);
                // setGetIntegrationListArray([]);


                NotificationPopups(
                    "error",
                    "NOT FOUND",
                    getAllGatewayMappingListRes.data.status
                );
            }
        }
    };

    useEffect(() => {
        if (getIntegrationListStatus) {
            getAllIntegrationMappingListFunc();
        }

    }, [getAllGatewayMappingListRes.data.status]);

    useEffect(() => {
        getAllGatewayMappingListReq();
    }, [pageNo, rowsPerPage]);

    useEffect(() => {
        if (getAllGatewayMappingListRes.data.status === "NOT FOUND") {
            setPageNo(0);
        }
    }, [getAllGatewayMappingListRes.data.status]);

    //    useEffect(() => {
    //     if (searchWalletOwnerId) {
    //         getAllGatewayMappingListReq();
    //     }

    // }, [pageNo, rowsPerPage])

    // useEffect(() => {
    //     if (getAllGatewayMappingListRes.data.status == "success") {
    //         setPageNo(0);
    //     }
    // }, [getAllGatewayMappingListRes.data.status]);

    // function pageNumberOne() {

    //     if (memberId || integrationname) {
    //         return 1
    //     } else {
    //         return 0
    //     }

    // }

    const getIntegrationTypeListReq = () => {
        // setGetIntegrationTypeStatus(true);
        const req = {
            ownerMasterRequestVO: {
                // adminId: 2
                adminId: val.adminIDS
            }
        };
        dispatch(
            adminGetIntegrationTypeList(req, regenerateTokenRes.data.AuthToken)
        );
    };
    const getWalletOwnerIdStatusFunc = () => {
        if (getWalletOwnerIdStatus) {
            if (getWalletOwnerIdRes.data.status == "success") {
                setGetWalletOwnerIdResArray(
                    [].concat(getWalletOwnerIdRes.data.ownerList)
                );
            }
            if (getWalletOwnerIdRes.data.status == "failed") {
                setGetWalletOwnerIdResArray(getWalletOwnerIdRes.data);
                if (
                    getWalletOwnerIdRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getWalletOwnerIdRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };
    useEffect(() => {
        getWalletOwnerIdStatusFunc();
    }, [getWalletOwnerIdRes.data.status]);

    const gateWayListFunc = (walletOwnerIDs) => {
        const getWayListReq = {
            walletOwnerId: walletOwnerIDs.split("-")[0],
            paymentBrand: "",
            paymentMode: "",

        };

        return dispatch(getWayList(getWayListReq, authToken));
    };

    const GateWayListsAdminFunc = (cardType, payMode) => {
        if (!payMode || !cardType) return;

        const req = {
            walletOwnerId: searchWalletOwnerIdModal.split("-")[0],
            paymentBrand: payMode,
            paymentMode: cardType,
            currency: user.Currency
        };

        dispatch(getWayListAdmin(req, authToken));
    };

    const customerIDandNameFunc = (walletOwnerIds) => {
        const req = {
            loginDetails: {
                walletOwnerId: walletOwnerIds.split("-")[0],
            },
            actionCustomerMasterRequestVO: {
                customerNameOrId: "",
            },
        };

        return dispatch(getCustomerIdAndNameList(req, authToken));
    };

    const customerIDandNameAdminFunc = (walletOwnerIds) => {
        const req = {
            loginDetails: {
                walletOwnerId: walletOwnerIds.split("-")[0],
            },
            actionCustomerMasterRequestVO: {
                customerNameOrId: "",
            },
        };

        return dispatch(getCustomerIDANDNameAdminList(req, authToken));
    };

    const getWalletOwnerIdAndNameListReq = () => {
        setGetWalletOwnerIdStatus(true);
        dispatch(
            getWalletOwnerIdAndNameList(
                {
                    loginDetails: {
                        // adminId: "2"
                        adminId: val.adminIDS

                    }
                },
                regenerateTokenRes.data.AuthToken
            )
        );
    };

    const CurrencyListFunc = (walletOwnerIds) => {
        const WalletAcRequired = {
            loginDetails: {
                walletOwnerId: walletOwnerIds.split("-")[0],
                role: login.data.subRole
            },
        };

        return dispatch(getDefaultCurrencyList(WalletAcRequired, authToken));
    };
    useEffect(() => {
        if (regenerateTokenRes.data.status === "success") {
            getWalletOwnerIdAndNameListReq();

        }
    }, [regenerateTokenRes.data.status]);

    const getPaymentBrandListFunc = (walletownerIds, paymentMode = "") => {
        const WalletAcRequired = {

            walletOwnerId: walletownerIds.split("-")[0],
            paymentMode: paymentMode          // ✅ passed from CardTypeID selection
        };

        return dispatch(getPaymentBrandList(WalletAcRequired, authToken));
    };

    // const getPaymentBrandListReq = () => {
    //     const req = {
    //         walletOwnerId: regenerateTokenRes.data.partnerId || "",
    //     }
    //     dispatch(getPaymentBrandList(req, authToken));
    // };

    // useEffect(() => {
    //     if (regenerateTokenRes.data.status == "success") {
    //         getPaymentBrandListReq()
    //         getPaymentModeListReq()
    //     }
    // }, [regenerateTokenRes.data.status])
    const getPaymentModeListFunc = (WalletownerIds) => {
        const WalletAcRequired = {

            walletOwnerId: WalletownerIds.split("-")[0],
            paymentBrand: ""

        };

        return dispatch(getPaymentModeList(WalletAcRequired, authToken));
    };

    // const getPaymentModeListReq = () => {
    //     const req = {
    //         walletOwnerId: regenerateTokenRes.data.partnerId || "",
    //         paymentBrand: ""
    //     }
    //     dispatch(getPaymentModeList(req, authToken));
    // }

    const createGatewayMappingReq = () => {
        let req = {
            walletOwnerId: searchWalletOwnerIdModal.split("-")[0] || "",
            merchantId: MemberID.split("-")[0],
            gatewayAccountIdList: [selectedGateway.gatewayId] // ✅ correct ID
            // gatewayAccountIdList: [Gateway.split("-")[0]]
        }
        dispatch(createGatewayMapping(req, authToken));
        // console.log('Create Account Request: ', req)
    };
    const handleChangeWallet = ({ target: { name, value } }) => {

        if (name === "searchWalletOwnerId") {
            setSearchWalletOwnerId(value == "Select Owner ID" ? "" : value);
            // getRolesOnWalletOwnerReq(value)
            // CurrencyListFunc(value)
            customerIDandNameFunc(value)
            gateWayListFunc(value)


        }
        if (name === "searchWalletOwnerIdModal") {
            setSearchWalletOwnerIdModal(value == "Select Owner ID" ? "" : value);
            // customerIDandNameFunc(value)
            customerIDandNameAdminFunc(value)
            CurrencyListFunc(value)
            // getPaymentBrandListFunc(value)
            getPaymentModeListFunc(value)
            // gateWayListFunc(value)
            // getRolesOnWalletOwnerReq(value)
            // CurrencyListFunc(value)

        }
        if (name === "CardTypeID") {
            const cardType = value;
            setUser(prev => ({ ...prev, CardTypeID: cardType }));
            getPaymentBrandListFunc(searchWalletOwnerIdModal, cardType);  // ✅ pass paymode
            // GateWayListsAdminFunc(cardType, user.PayModeID);
        }
        console.log("UPDATE USER", user)
        // if (name === "searchWalletOwnerIdModal") {
        //     setSearchWalletOwnerIdModal(value == "Select Owner ID" ? "" : value);
        //     // getRolesOnWalletOwnerReq(value)
        //     CurrencyListFunc(value)

        // }
    };
    // Handle Changes
    const handleChange = ({ target: { name, value } }) => {
        // if (name === "searchWalletOwnerId") {
        //     setSearchWalletOwnerId(value);
        // }
        // if (name === "memberId") {
        //     Util.verifyAlphabet(value)
        //         ? setMemberId(value)
        //         : setMemberId(memberId)
        // }
        if (name === "memberId") {
            setMemberId(value)
        }
        if (name === "integrationname") {
            setIntegrationName(value)
        }
        if (name === "searchIntegrationType") {
            setSearchIntegrationType(value == "All" ? "" : value);
            setDialogIntegrationType(value == "All" ? "" : value); // ✅ add this
            setUser(prev => ({ ...prev, Gateway: "" })); // ✅ clear stale gateway
        }
        // if (name === "gateway") {
        //     Util.verifyAlphabet(value) ? setUser(value) : setUser(Gateway)
        // }
    };
    // HandleClose

    const handleClose = () => {
        setUser({
            MemberID: "",
            PayModeID: "",
            CardTypeID: "",
            Gateway: "",
        });
        // setOpen(false);
        // setEditOpen(false);
        // setViewOpen(false);
        setAddOpen(false);
        setDialogIntegrationType("");

    };

    const handleDeleteClose = () => {
        setDeleteMapId("value");
        setopenConfirm(false);
    }

    const deleteMappingFunc = (value) => {
        setDeleteMapId(value);
        setopenConfirm(true);
    };

    const deleteMappingFuncHandler = () => {

        const req = {
            mappingId: deleteMapId,
            walletOwnerId: regenerateTokenRes.data.partnerId
        }

        dispatch(deleteGatewayMapping(req, authToken));
    }

    // Functions
    const addRole = (e) => {
        setUser
            ({
                MemberID: "",
                PayModeID: "",
                CardTypeID: "",
                Gateway: "",
            });
        // setNotificationOpen(false);
        // setEditOpen(false);
        // setViewOpen(false);
        setAddOpen(true);
    };

    // const getWalletOwnerIdStatusFunc = () => {
    //     if (getWalletOwnerIdStatus) {
    //         if (getWalletOwnerIdRes.data.status == "success") {
    //             setGetWalletOwnerIdResArray(
    //                 [].concat(getWalletOwnerIdRes.data.ownerList)
    //             );
    //         }
    //         if (getWalletOwnerIdRes.data.status == "failed") {
    //             setGetWalletOwnerIdResArray(getWalletOwnerIdRes.data);
    //         }
    //     }
    // };

    // Table view,edit
    // const setData = (row, fs) => {
    //     setUser({
    //         MemberID: row.MemberID,
    // user.        PayModeuser.ID: row.PayModeID,
    //         CardTypeID: row.CardTypeID,
    //         Gateway: row.Gateway,
    //     });
    //     if (fs == "view") {
    //         setEditOpen(false);
    //         setNotificationOpen(false);
    //         setViewOpen(true);

    //     }
    //     if (fs == "edit") {
    //         setNotificationOpen(false);
    //         setViewOpen(false);
    //         setEditOpen(true);
    //     }
    // };


    useEffect(() => {
        return () => {
            dispatch(resetGetCustomerIdAndNameList());
            dispatch(resetGetPaymentModeList());
            dispatch(resetGetPaymentBrandList());
            dispatch(resetGetWayList());
            dispatch(resetAllGatewayMappingList());
            dispatch(resetAdminGetIntegrationTypeList());
            dispatch(resetGetWalletOwnerIdAndNameList());
            dispatch(resetCreateGatewayMapping());
            dispatch(resetDeleteGatewayMapping());
        }
    }, [])

    // useEffect(() => {
    //     console.log("SETMEM", getCustomerIdAndNameListRes)
    //     if (getCustomerIdAndNameListRes.data.status === "NOT FOUND") {
    //         setMemberId(getCustomerIdAndNameListRes.data.status)
    //     }
    // }, [getCustomerIdAndNameListRes])
    const filterOptionsL = (options, { inputValue }) => {
        if (inputValue.length < 3) {
            return [];
        }

        const filterOptionsList = options.filter(
            (option) => option.includes(inputValue) || ""
        );

        return filterOptionsList.slice(0, 20);
    };
    const filterOptionsLisss = (options, { inputValue }) => {
        if (inputValue.length < 3) {
            return [];
        }

        const filterOptionsList = options.filter(
            (option) => option.includes(inputValue) || ""
        );

        return filterOptionsList.slice(0, 20);
    };

    const memberList =
        getCustomerIdAndNameAdminListRes?.data?.currencyList || [];

    const filteredMembers =
        memberSearch.length >= 3
            ? memberList.filter((id) =>
                id.toString().includes(memberSearch)
            )
            : [];

    const IntegrationName = getWayListAdminRes?.data?.gatewayRequestVOList?.[0]?.integrationName
    console.log("IntegrationName", IntegrationName)



    // Auto-populate Gateway field when getWayListAdmin returns data
    // useEffect(() => {
    //     if (getWayListAdminRes?.data?.status === "success" &&
    //         getWayListAdminRes?.data?.gatewayRequestVOList?.length > 0) {
    //         const firstGateway = getWayListAdminRes.data.gatewayRequestVOList[0];
    //         const gatewayValue = `${firstGateway.gatewayId}`;
    //         setUser(prev => ({ ...prev, Gateway: gatewayValue }));
    //     }
    // }, [getWayListAdminRes?.data?.status, getWayListAdminRes?.data?.gatewayRequestVOList]);
    // useEffect(() => {
    //     if (
    //         getWayListAdminRes?.data?.status === "success" &&
    //         getWayListAdminRes?.data?.gatewayRequestVOList?.length > 0
    //     ) {
    //         const g = getWayListAdminRes.data.gatewayRequestVOList[0];

    //         setSelectedGateway({
    //             gatewayId: g.gatewayId,
    //             integrationName: g.integrationName
    //         });

    //         setUser(prev => ({
    //             ...prev,
    //             Gateway: g.integrationName // UI value
    //         }));
    //     }
    // }, [getWayListAdminRes?.data?.status]);

    // useEffect(() => {
    //     if (getWayListAdminRes?.data?.status === "success") {
    //         const rawList = getWayListAdminRes.data.gatewayRequestVOList;

    //         // API returns an object, not an array — normalize it
    //         const list = Array.isArray(rawList)
    //             ? rawList
    //             : rawList && typeof rawList === "object"
    //                 ? [rawList]
    //                 : [];

    //         if (list.length > 0) {
    //             const g = list[0];
    //             setSelectedGateway({ gatewayId: g.gatewayId, integrationName: g.integrationName });
    //             setUser(prev => ({ ...prev, Gateway: g.integrationName }));
    //         }
    //     }
    // }, [getWayListAdminRes?.data?.status, getWayListAdminRes?.data?.gatewayRequestVOList]);

    // Add this helper function at the top of your component
    const normalizePaymentBrandList = (brandList) => {
        if (!brandList) return [];
        if (typeof brandList === 'string') return [brandList];
        if (Array.isArray(brandList)) return brandList;
        return [];
    };

    useEffect(() => {
        if (getIntegrationTypeListRes.data.status === "success") {
            setGetIntegrationTypeArray(
                [].concat(getIntegrationTypeListRes.data.integrationTypeList)
            );
        }
        if (getIntegrationTypeListRes.data.status === "failed") {
            if (getIntegrationTypeListRes.data.description === "session out") {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (getIntegrationTypeListRes.data.description === "Authorization failed") {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }, [getIntegrationTypeListRes.data.status]);

    useEffect(() => {
        if (dialogIntegrationType && searchWalletOwnerIdModal && regenerateTokenRes.data.status === "success") {
            const req = {
                walletOwnerId: searchWalletOwnerIdModal.split("-")[0],
                paymentBrand: "",
                paymentMode: "",
                currency: user.Currency || "",
                integrationType: dialogIntegrationType
            };
            dispatch(getWayListAdmin(req, authToken));
        }
    }, [dialogIntegrationType, searchWalletOwnerIdModal]);



    return (
        <>
            <Layout>
                <Card>
                    <Grid
                        container
                        style={{
                            padding: "10px",
                            marginTop: "1rem",
                            marginLeft: "1rem"
                        }}
                    >
                        <Grid item md={4} sm={12} lg={9}></Grid>
                        <Grid item md={4} sm={12} lg={3}>
                            <CustomButton
                                variant="contained"
                                style={{ backgroundColor: "#00b9f5", color: "white" }}
                                size="small"
                                onClick={() => addRole()}
                            >
                                Create Mapping
                            </CustomButton>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} style={{ padding: "25px", gap: "10px" }}>

                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <TextField
                                required
                                margin="dense"

                                select
                                // style={{ marginTop: "3px" }}
                                variant="standard"
                                color="primary"
                                type="text"
                                label="Wallet Owner ID"
                                fullWidth
                                name="searchWalletOwnerId"
                                // value={walletOwnerId}
                                defaultValue={"Select Owner Id" || searchWalletOwnerId}
                                onChange={handleChangeWallet}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}

                            >
                                <MenuItem value="Select Owner Id" selected="Select Owner Id">
                                    Select Owner Id
                                </MenuItem>
                                {console.log("GETARRAYowner", getWalletOwnerIdResArray)}
                                {getWalletOwnerIdResArray.status !== "failed" && getWalletOwnerIdRes.data.ownerList &&
                                    getWalletOwnerIdResArray.map((x) => (
                                        <MenuItem value={x.split("-")[0]}>{x}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <Autocomplete
                                id="combo-box-demo"
                                options={[].concat(
                                    getCustomerIdAndNameListRes.data.status == "NOT FOUND" ? "NOT FOUND" : getCustomerIdAndNameListRes.data.currencyList || [""]
                                )}
                                getOptionLabel={(option) => option}
                                filterOptions={filterOptionsL}
                                renderInput={(params) => (
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="memberId"
                                        label="Member ID"
                                        variant="standard"

                                        type="text"
                                        fullWidth
                                        {...params}
                                        value={memberId}
                                        name="memberId"
                                        onBlur={handleChange}
                                        sx={{
                                            "& .MuiInput-underline:before": {
                                                borderBottomColor: "gray", // White color for the underline before focus
                                            },
                                            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                borderBottomColor: "gray", // White color on hover
                                            },
                                            "& .MuiInput-underline:after": {
                                                borderBottomColor: "gray", // White color after focus
                                            },
                                        }}
                                    />
                                )}
                            />
                        </Grid>


                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <Autocomplete
                                id="combo-box-demo"

                                options={[].concat(
                                    getWayListRes.data.gatewayRequestVOList || [""]
                                )}
                                getOptionLabel={(user) => `${user.gatewayId}-${user.integrationName}-${user.currency}-${user.paymentBrand}-${user.paymentMode}`}
                                filterOptions={filterOptions}
                                renderInput={(params) => (
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="integrationname"
                                        label="Integration Named"
                                        variant="standard"

                                        type="text"
                                        fullWidth
                                        {...params}
                                        value={integrationname}
                                        name="integrationname"
                                        onBlur={handleChange}
                                        InputProps={{
                                            sx: {
                                                "&:before": { borderBottomColor: "gray" }, // before focus
                                                "&:after": { borderBottomColor: "gray" },  // after focus
                                            },
                                        }}
                                        InputLabelProps={{
                                            sx: { color: 'gray' }, // Optional: if you want the label to be white
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} sm={12} md={2} lg={2}>
                            <CustomButton
                                style={{
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={getAllGatewayMappingListReq}
                                endIcon={<AiOutlineSearch />}
                            >
                                Search
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>

                {/* {getAllGatewayMappingListRes.isLoading ? (
                    <LoadingSpinner />
                ) : getAllGatewayMappingListRes.length || getAllGatewayMappingListRes.success ? ( */}
                {isLoading ? (
                    <LoadingSpinner />
                ) : getIntegrationListArray.length == undefined ||
                    !getIntegrationListStatus ? (

                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}
                                    className="themeText"

                                >
                                    Member Mapping
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 tableHeaderColor"
                                    variant="secondary"

                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>

                ) : (
                    // <Card>
                    //     <Grid
                    //         container
                    //         style={{
                    //             padding: "10px"
                    //         }}
                    //     >
                    //         <Grid xs={12} sm={12} md={12} lg={12}>
                    //             <Typography variant="body1" style={{ fontWeight: "700" }}
                    //                 className="themeText"

                    //             >
                    //                 Member Mapping
                    //             </Typography>
                    //         </Grid>
                    //         <Grid xs={12} sm={12} md={12} lg={12}>
                    //             <Alert
                    //                 className="my-3 tableHeaderColor"
                    //                 variant="secondary"

                    //             >
                    //                 No Records Found!
                    //             </Alert>
                    //         </Grid>
                    //     </Grid>
                    // </Card>

                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}
                                    className="themeText"
                                >
                                    Member Mapping
                                </Typography>
                            </Grid>
                            <TableContainer component={Paper} className="my-3">
                                <Table
                                    className={classes.table}
                                    size="small"
                                    aria-label="a dense table"
                                >
                                    <TableHead>
                                        <TableRow className="tableHeaderColor">
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Wallet Owner Id
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Merchant Id
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Integration Name
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Gateway Id
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Mapping Id
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Action
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {/* {getAllGatewayMappingListRes.data.gatewayRequestVOList &&
                                            [].concat(getAllGatewayMappingListRes.data.gatewayRequestVOList)
                                                .slice(
                                                    page * rowsPerPage,
                                                    page * rowsPerPage + rowsPerPage
                                                ) */}
                                        {getIntegrationListArray &&
                                            []
                                                .concat(getIntegrationListArray)
                                                // .slice(
                                                //     page * rowsPerPage,
                                                //     page * rowsPerPage + rowsPerPage
                                                // )
                                                .map((row, index) => (
                                                    <TableRow>
                                                        <TableCell align="center">
                                                            {row.walletOwnerId}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.merchantId}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.integrationName}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.gatewayId}-{row.paymentMode}-{row.paymentBrand}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.mappingId}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <Tooltip title="Delete">
                                                                <CustomButton
                                                                    style={{
                                                                        padding: "8px"
                                                                    }}
                                                                    onClick={() =>
                                                                        deleteMappingFunc(row.mappingId)
                                                                    }
                                                                >
                                                                    {
                                                                        <DeleteIcon
                                                                            style={{
                                                                                color: "#fff",
                                                                                fontSize: "20px"
                                                                            }}
                                                                        />
                                                                    }
                                                                </CustomButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    // count={getIntegrationListArray.length}
                                    // count={Number(getAllGatewayMappingListRes.data.count)}
                                    count={
                                        getAllGatewayMappingListRes.data.status === "success"
                                            ? Number(getAllGatewayMappingListRes.data.count || 0)
                                            : 0
                                    }
                                    rowsPerPage={rowsPerPage}
                                    page={pageNo}
                                    onPageChange={handleChangePageForward}
                                    onRowsPerPageChange={handleChangeRowsPerPage}


                                // handleChangeRowsPerPage={handleChangeRowsPerPage}
                                // page={page}
                                // onChangePage={handleChangePage}
                                // onChangeRowsPerPage={handleChangeRowsPerPage}
                                />
                            </TableContainer>
                        </Grid>
                    </Card>
                )}


                <div>
                    <Dialog open={openConfirm} onClose={handleDeleteClose}>
                        <DialogTitle style={{ width: "400px" }}>Are you sure?</DialogTitle>
                        <DialogActions className="p-3">
                            <CustomButton
                                style={{
                                    backgroundColor: "#fff",
                                    color: "#000"
                                }}
                                variant="contained"
                                onClick={handleDeleteClose}
                            >
                                Cancel
                            </CustomButton>
                            <CustomButton
                                style={{
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={deleteMappingFuncHandler}
                            >
                                Yes
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            </Layout>


            <div>
                <Dialog open={addOpen} onClose={handleClose} fullWidth>
                    <DialogTitle>Create Account</DialogTitle>
                    <DialogContent>

                        {/* <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Member ID"
                            fullWidth={true}
                            name="MemberID"
                            value={MemberID || ""}
                            onChange={(e) => onInputChange(e, "alphabet")}
                        ></TextField> */}

                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Integration Type"
                                fullWidth={true}
                                name="searchIntegrationType"
                                defaultValue={"All" || searchIntegrationType}
                                onChange={handleChange}
                                placeholder="Please Select Currency"
                                variant="standard"
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}

                            >
                                <MenuItem value="All" selected="All">
                                    Select Integration Type
                                </MenuItem>
                                {getIntegrationTypeListRes.data.integrationTypeList &&
                                    getIntegrationTypeArray.map((x) => (
                                        <MenuItem value={x}>{x}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>


                        <TextField
                            required
                            margin="dense"
                            variant="standard"
                            select
                            style={{ marginTop: "3px" }}

                            color="primary"
                            type="text"
                            label="Partner ID"
                            fullWidth
                            name="searchWalletOwnerIdModal"
                            // value={walletOwnerId}
                            defaultValue={"Select Owner Id" || searchWalletOwnerIdModal}
                            onChange={handleChangeWallet}
                            sx={{
                                "& .MuiInput-underline:before": {
                                    borderBottomColor: "gray", // White color for the underline before focus
                                },
                                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                    borderBottomColor: "gray", // White color on hover
                                },
                                "& .MuiInput-underline:after": {
                                    borderBottomColor: "gray", // White color after focus
                                },
                            }}

                        >
                            <MenuItem value="Select Owner Id" selected="Select Owner Id">
                                Select Owner Id
                            </MenuItem>
                            {console.log("GETARRAYowner", getWalletOwnerIdResArray)}
                            {getWalletOwnerIdResArray.status !== "failed" && getWalletOwnerIdRes.data.ownerList &&
                                getWalletOwnerIdResArray.map((x) => (
                                    <MenuItem value={x.split("-")[0]}>{x}</MenuItem>
                                ))}
                        </TextField>


                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            {/* <Autocomplete
                                id="combo-box-demo"
                                options={[].concat(
                                    // getCustomerIdAndNameAdminListRes.data.currencyList || [""]
                                    getCustomerIdAndNameAdminListRes.data.status == "NOT FOUND" ? "NOT FOUND" : getCustomerIdAndNameAdminListRes.data.currencyList || [""]

                                )}
                                // onChange={(e) => onInputChange(e)}
                                getOptionLabel={(option) => option}
                                filterOptions={filterOptionsLisss}
                                PopperProps={{
                                    style: { zIndex: 2000 }
                                }}
                                // onChange={(e) => onInputChange(e)}
                                renderInput={(params) => (
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="memberId"
                                        label="Member IDM"
                                        required
                                        name="MemberID"
                                        value={MemberID}
                                        type="text"
                                        variant="standard"
                                        fullWidth
                                        {...params}
                                        onBlur={(e) => onInputChange(e)}
                                        sx={{
                                            "& .MuiInput-underline:before": {
                                                borderBottomColor: "gray", // White color for the underline before focus
                                            },
                                            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                borderBottomColor: "gray", // White color on hover
                                            },
                                            "& .MuiInput-underline:after": {
                                                borderBottomColor: "gray", // White color after focus
                                            },
                                        }}
                                    />
                                )}
                            /> */}
                            <TextField
                                label="Member ID"
                                variant="standard"
                                fullWidth
                                value={memberSearch}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setMemberSearch(value);

                                    if (value.length >= 3) {
                                        setAnchorEl(e.currentTarget);
                                    } else {
                                        setAnchorEl(null);
                                    }
                                }}
                                InputProps={{
                                    endAdornment: memberSearch ? (
                                        <InputAdornment position="end">
                                            <IconButton
                                                size="small"
                                                onClick={() => {
                                                    setMemberSearch("");
                                                    setMemberId("");
                                                    setUser(prev => ({
                                                        ...prev,
                                                        MemberID: ""
                                                    }));
                                                    setAnchorEl(null);
                                                }}
                                            >
                                                <ClearIcon fontSize="small" />
                                            </IconButton>
                                        </InputAdornment>
                                    ) : null,
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" },
                                        "&:after": { borderBottomColor: "gray" },
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: "gray" },
                                }}
                            />


                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={() => setAnchorEl(null)}
                            >
                                {filteredMembers.length > 0 ? (
                                    filteredMembers.map((id) => (
                                        <MenuItem
                                            key={id}
                                            onClick={() => {
                                                setMemberId(id);
                                                setMemberSearch(id);
                                                setUser(prev => ({
                                                    ...prev,
                                                    MemberID: id
                                                }));
                                                setAnchorEl(null);
                                            }}
                                        >
                                            {id}
                                        </MenuItem>
                                    ))
                                ) : (
                                    <MenuItem disabled>No results</MenuItem>
                                )}
                            </Menu>




                        </Grid>
                        {dialogIntegrationType !== "CURRENCY_CONVERSION" && (
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Currency"
                                fullWidth={true}
                                name="Currency"
                                value={user.Currency}
                                variant="standard"
                                // defaultValue={"All" || searchCurrency}
                                // onChange={handleChange}
                                onChange={(e) =>
                                    setUser(prev => ({
                                        ...prev,
                                        Currency: e.target.value
                                    }))
                                }
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            >
                                <MenuItem value="All" selected="All	">
                                    Select Currency
                                </MenuItem>
                                {adminCurrencyList.success &&
                                    []
                                        .concat(adminCurrencyList.data.currencyList)
                                        .map((x) => <MenuItem value={x}>{x}</MenuItem>)}
                            </TextField>
                        )}

                        {dialogIntegrationType !== "CURRENCY_CONVERSION" && (
                            <TextField
                                required
                                style={{ marginTop: "10px" }}
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label=" PayMode"
                                fullWidth={true}
                                name="CardTypeID"
                                variant="standard"
                                defaultValue={"All" || CardTypeID}
                                // onChange={(e) => onInputChange(e)}
                                onChange={handleChangeWallet}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}

                            >
                                <MenuItem value="All" selected="All">
                                    Select Card Type
                                </MenuItem>
                                {getPaymentModeListRes.data.paymentBrandList &&
                                    [].concat(getPaymentModeListRes.data.paymentBrandList)
                                        .map((x) => (
                                            <MenuItem value={x}>
                                                {x}
                                            </MenuItem>
                                        ))}
                            </TextField>)}

                        {dialogIntegrationType !== "CURRENCY_CONVERSION" && (
                            <TextField
                                style={{ marginTop: "10px" }}
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="PayBrand"
                                fullWidth
                                variant="standard"
                                name="PayModeID"
                                value={PayModeID || "All"}
                                // onChange={onInputChange}
                                onChange={(e) => {
                                    onInputChange(e);   // still update user.PayModeID state
                                    const selectedBrand = e.target.value;
                                    if (selectedBrand && selectedBrand !== "All") {
                                        const req = {
                                            walletOwnerId: searchWalletOwnerIdModal.split("-")[0],
                                            paymentBrand: selectedBrand,       // selected PayBrand
                                            paymentMode: user.CardTypeID,      // previously selected PayMode
                                            currency: user.Currency
                                        };
                                        dispatch(getWayListAdmin(req, authToken));
                                    }
                                }}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" },
                                        "&:after": { borderBottomColor: "gray" },
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: "gray" },
                                }}
                            >
                                <MenuItem value="All">
                                    Select PayBrand
                                </MenuItem>

                                {/* {Array.isArray(getPaymentBrandListRes?.data?.paymentBrandList) &&
                                getPaymentBrandListRes.data.paymentBrandList
                                    .filter(x => typeof x === "string")
                                    .map((x) => (
                                        <MenuItem key={x} value={x}>
                                            {x}
                                        </MenuItem>
                                    ))} */}

                                {/* ✅ CLEAN: Use helper function */}
                                {normalizePaymentBrandList(getPaymentBrandListRes?.data?.paymentBrandList)
                                    .filter(x => typeof x === "string" && x.trim() !== "")
                                    .map((x) => (
                                        <MenuItem key={x} value={x}>
                                            {x}
                                        </MenuItem>
                                    ))
                                }
                            </TextField>
                        )}


                        {/* <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Gateway"
                            fullWidth={true}
                            name="Gateway"
                            value={Gateway || ""}
                            onChange={(e) => onInputChange(e, "alphabet")}
                        ></TextField>  */}
                        {/* <Autocomplete
                            id="combo-box-demo"
                            options={[].concat(
                                getWayListAdminRes.data.gatewayRequestVOList || [""]
                            )}
                            getOptionLabel={(user) => `${user.gatewayId}-${user.integrationName}-${user.currency}-${user.paymentBrand}-${user.paymentMode}`}
                            filterOptions={filterOptions} 
                            // onChange={(e) => onInputChange(e)}
                            renderInput={(params) => ( */}
                        {/* <TextField
                            autoFocus
                            margin="dense"
                            id="gateway"
                            label="Gateway"
                            required
                            type="text"
                            variant="standard"
                            fullWidth
                            value={Gateway}
                            name="Gateway"
                            onChange={(e) => onInputChange(e)}
                            InputProps={{
                                readOnly: true,
                                sx: {
                                    "&:before": { borderBottomColor: "gray" },
                                    "&:after": { borderBottomColor: "gray" },
                                },
                            }}
                            InputLabelProps={{
                                sx: { color: 'gray' },
                            }}
                        /> */}


                        {/* )}
                        />  */}

                        {/* <TextField
                            disabled
                            autoFocus
                            margin="dense"
                            id="gateway"
                            label="Gateway"
                            required
                            type="text"
                            variant="standard"
                            fullWidth
                            value={IntegrationName || ""}
                            // value={Gateway}
                            name="Gateway"
                            onBlur={(e) => onInputChange(e)}
                            InputProps={{
                                sx: {
                                    "&:before": { borderBottomColor: "gray" }, // before focus
                                    "&:after": { borderBottomColor: "gray" },  // after focus
                                },
                            }}
                            InputLabelProps={{
                                sx: { color: 'gray' }, // Optional: if you want the label to be white
                            }}
                        // onBlur={handleChange}
                        /> */}

                        <Autocomplete
                            id="combo-box-demo"
                            options={
                                Array.isArray(getWayListAdminRes?.data?.gatewayRequestVOList)
                                    ? getWayListAdminRes.data.gatewayRequestVOList
                                    : getWayListAdminRes?.data?.gatewayRequestVOList
                                        ? [getWayListAdminRes.data.gatewayRequestVOList]
                                        : []
                            }
                            getOptionLabel={(option) =>
                                option && option.gatewayId
                                    ? `${option.gatewayId}-${option.memberUserName}-${option.memberId}-${option.currency}-${option.paymentBrand}-${option.paymentMode}-${option.isTest}`
                                    : ""
                            }
                            filterOptions={filterOptions}
                             componentsProps={{
                                popper: {
                                    style: { zIndex: 9999 }
                                }
                            }}
                            onChange={(event, newValue) => {
                                if (newValue) {
                                    setSelectedGateway({
                                        gatewayId: newValue.gatewayId,
                                        integrationName: newValue.integrationName
                                    });
                                    setUser(prev => ({ ...prev, Gateway: newValue.integrationName }));
                                }
                            }}
                            renderInput={(params) => (
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    id="gateway"
                                    label="Gateway"
                                    required
                                    type="text"
                                    variant="standard"
                                    fullWidth
                                    {...params}
                                    name="Gateway"
                                    InputProps={{
                                        ...params.InputProps,
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" },
                                            "&:after": { borderBottomColor: "gray" },
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: "gray" },
                                    }}
                                />
                            )}
                        />



                    </DialogContent>

                    <DialogActions style={{ padding: "14px" }}>
                        <CustomButton
                            style={{
                                backgroundColor: "#fff",
                            }}
                            variant="contained"
                            onClick={handleClose}
                            className="cancelbtncreatemapping"
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                backgroundColor: "#00b9f5",
                                color: "white"
                            }}
                            variant="contained"
                            onClick={createGatewayMappingReq}
                        >
                            Add
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div >
        </>
    )
}

export default AdminMemberMapping